interface SlideTarget {
  animate: (
    frames: Keyframe[],
    options: KeyframeAnimationOptions,
  ) => Pick<Animation, "finished" | "cancel">;
}

/** Cancellation must never let an old completion remove the current panel. */
export function playSidebarSlide(
  incoming: SlideTarget,
  outgoing: SlideTarget,
  direction: 1 | -1,
  options: KeyframeAnimationOptions,
  onFinish: () => void,
): () => void {
  const animations = [
    incoming.animate(
      [{ transform: `translateX(${direction * 100}%)` }, { transform: "translateX(0)" }],
      options,
    ),
    outgoing.animate(
      [{ transform: "translateX(0)" }, { transform: `translateX(${-direction * 100}%)` }],
      options,
    ),
  ];
  let cancelled = false;
  const cancel = () => {
    cancelled = true;
    animations.forEach((animation) => {
      animation.cancel();
    });
  };
  void Promise.all(animations.map((animation) => animation.finished))
    .then(() => {
      if (!cancelled) {
        cancel();
        onFinish();
      }
    })
    .catch(() => {
      /* A newer navigation superseded this transition. */
    });
  return cancel;
}

export function shouldCloseMobileNavigation(
  previous: { payroll: boolean; workspaceId: string },
  next: { payroll: boolean; workspaceId: string },
): boolean {
  return previous.workspaceId !== next.workspaceId || previous.payroll === next.payroll;
}
